import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { AuthUser } from '@libraries/api/gen-api';

import WithCenter from '../layout/WithCenter';

import { RootState, store } from '../../store';

import { isServiceConsole } from '../../helpers';

function FourOhFour() {
  const { t } = useTranslation();
  const showSSOHelper: boolean = useSelector(store.select.auth.showSSOLoginHelper);
  const me: AuthUser = useSelector((state: RootState) => state.auth.me);
  const disablePath = useSelector(store.select.auth.isTabDisabled);
  let consolePath = disablePath ? '/settings/sso-configuration' : '/dashboard';
  let linkText = disablePath ? t('go_to_settings') : t('go_to_dashboard');
  if (showSSOHelper) {
    consolePath = '/sso-helper';
    linkText = t('sso.go_to_SSO_helper');
  }

  return (
    <WithCenter>
      <h1>404</h1>
      <p>{t('errors.page_not_found')}</p>
      <Link to="/login">{t('go_to_login')}</Link>
      {me?.org && <Link to={isServiceConsole ? '/admin/dashboard' : consolePath}>{linkText}</Link>}
    </WithCenter>
  );
}

export default FourOhFour;
